<div aria-labelledby="slide-over-title" role="dialog" aria-modal="true" class="fixed z-50">
  <div class="fixed inset-0 bg-[#363738] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]"></div>
  <div class="fixed inset-0 overflow-hidden">
    <div class="absolute inset-0 overflow-hidden">
      <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
        <div class="w-screen max-w-xl px-4 py-4">
          <div class="flex flex-col overflow-y-auto px-4 py-4">
            <div aria-labelledby="slide-over-title" role="dialog" aria-modal="true" class="fixed z-50">
              <div
                class="fixed inset-0 bg-[#D4D7DE] bg-opacity-25 backdrop-blur-sm transition-opacity dark:bg-[#3333331f]">
              </div>
              <div class="fixed inset-0 overflow-hidden">
                <div class="absolute inset-0 overflow-hidden">
                  <div class="fixed inset-y-0 right-0 flex max-w-full pl-4 sm:pl-8">
                    <div class="w-screen overflow-hidden p-4">
                      <div
                        class="flex h-full flex-col overflow-hidden rounded-lg border border-zinc-950/10 bg-white shadow-xl dark:border-white/10 dark:bg-zinc-950">
                        <div class="border-b border-zinc-200 px-4 py-2 dark:border-white/10">
                          <div class="flex items-center justify-between">
                            <h3 id="slide-over-title" class="heading">Distribution</h3>
                            <div *ngIf="false" class="flex justify-between items-center space-x-3">
                              <div class="flex justify-end">
                                <div class="flex justify-end">
                                  <div class="bg-gray-100 dark:bg-zinc-900 p-1 rounded-xl flex shadow-sm">
                                    <!-- Normal Tab -->
                                    <button type="button" (click)="setTab('company')"
                                      [ngClass]="tab === 'company'
                                                                                ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                                                                                : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                                      Company
                                    </button>

                                    <!-- Percentage Tab -->
                                    <button type="button" (click)="setTab('driver')"
                                      [ngClass]="tab === 'driver'
                                                                                ? 'bg-white text-gray-900 shadow dark:bg-gray-800 dark:text-white'
                                                                                : 'text-gray-500 hover:text-gray-900 dark:hover:text-gray-300'"
                                      class="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200">
                                      Driver
                                    </button>
                                  </div>
                                </div>
                              </div>

                              <div class="ml-3 flex h-7 items-center space-x-4">
                                <button (click)="onCloseModal()"
                                  class="rounded-md bg-white text-zinc-500 hover:text-zinc-700 focus:ring-2 focus:ring-primary dark:bg-white/5 dark:text-white dark:hover:text-zinc-300"
                                  type="button">
                                  <span class="sr-only">Close panel</span>
                                  <svg aria-hidden="true" class="h-6 w-6" fill="none" stroke="currentColor"
                                    stroke-width="1.5" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6M6 6l12 12" stroke-linecap="round" stroke-linejoin="round">
                                    </path>
                                  </svg>
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="mt-2 mr-4 ml-auto w-20 flex items-center border rounded-md border-main-base shadow p-1 gap-1 bg-[#D4D7DE] dark:border-gray-600 dark:bg-zinc-900">
                          <div class="text-black text-sm font-medium px-1 dark:text-white">
                            Map
                          </div>
                          <!-- Rotating chevron -->
                          <div (click)="onShowMap()"
                            class="p-1 rounded cursor-pointer select-none border border-1 text-main-secondary bg-white dark:bg-gray-600">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 transition-transform duration-200"
                              [ngClass]="{ 'rotate-180': !showMap }" fill="none" viewBox="0 0 24 24"
                              stroke="currentColor" stroke-width="2">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
                            </svg>
                          </div>
                        </div>
                        <div [hidden]="!showMap"
                          class="mt-2 z-0 h-96 lg:h-full lg:flex-1 overflow-y-auto focus:outline-none p-2 rounded-lg bg-white dark:bg-zinc-950 ring-1 ring-zinc-200 dark:ring-white/5">
                          <google-map #googleMap height="100%" width="100%" [center]="center" [zoom]="zoom">
                            <ng-container *ngFor="let item of trips">
                              <map-marker #marker="mapMarker" (mapClick)="openInfo(marker, item)"
                                [position]="{ lat: item.pickup.address.coords[1], lng: item.pickup.address.coords[0] }">
                              </map-marker>
                            </ng-container>

                            <map-info-window #infoWindow class="w-40">
                              <div class="text-xs font-medium text-gray-900">
                                Name:
                                <span class="text-gray-500">{{ selectedTrip?.member?.displayName }}</span>
                              </div>
                              <div *ngIf="selectedTrip?.pickup?.address" class="text-xs text-gray-900 w-40">
                                <span class="font-medium">Address:</span>
                                <span class="text-[9px] text-main-primary"><u>{{ selectedTrip.pickup.address.name
                                    }}</u></span>
                              </div>
                            </map-info-window>
                          </google-map>
                        </div>
                        <div class="mt-2 flex flex-1 flex-col items-start gap-4 overflow-hidden p-4 lg:flex-row">
                          <div
                            class="h-full w-full flex-shrink-0 overflow-hidden rounded-lg border border-zinc-950/10 dark:border-white/10 lg:w-80">
                            <ul class="h-full divide-y divide-zinc-950/10 overflow-y-auto dark:divide-white/10">
                              <div class="flex justify-between items-center px-4 py-2">
                                <div class="p-2">
                                  <div class="relative">
                                    <input type="text" [(ngModel)]="search2" placeholder="Search.."
                                      class="ng-untouched ng-pristine ng-valid pl-8" /><svg
                                      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                      stroke-width="1.5" stroke="currentColor"
                                      class="absolute left-2 top-1/2 size-5 -translate-y-1/2 transform">
                                      <path stroke-linecap="round" stroke-linejoin="round"
                                        d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z">
                                      </path>
                                    </svg>
                                  </div>
                                </div>
                                <div>
                                  <button class="btn btn-secondary rounded-md px-2 py-1 text-xs" type="button"
                                    (click)="selectAll()">
                                    {{allSelected ? 'Unselect All' : 'Select All'}}
                                  </button>
                                </div>
                              </div>
                              <ng-container *ngIf="tab ==='company'">
                                <li *ngFor="let item of companies | filter : search2" (click)="onSelectCompany(item)"
                                  class="relativs relative cursor-pointer  px-4 py-2 hover:bg-gray-100 dark:bg-white/5 dark:hover:bg-white/5"
                                  [ngClass]="selectedCompanies.includes(item.id) ? 'bg-gray-200' : 'bg-white'">
                                  <span class="absolute inset-y-0 left-0 z-10 h-full w-2"
                                    [ngClass]="selectedCompanies.includes(item.id) ? 'bg-blue-800' : 'bg-gray-200 dark:bg-white/10'">
                                  </span>
                                  <div class="flex items-center justify-between">
                                    <div class="flex flex-1 items-center gap-2">
                                      <div
                                        class="inline-grid size-10 shrink-0 rounded-[--avatar-radius] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--avatar-radius:20%] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity] overflow-hidden">
                                        <img alt="Profile Image"
                                          class="ng-star-inserted relative size-full text-gray-400 object-cover"
                                          src="{{item.profileImageURL ? item.profileImageURL : 'assets/images/company-placeholder.png'}}" />
                                      </div>
                                      <div class="flex flex-col">
                                        <div class="text-sm-dark font-bold leading-tight text-primary">{{(item.name) | titlecase}}
                                        </div>
                                        <div class="text-sm-light leading-tight" phoneNumberFormat [phoneNumber]="item.phoneNumber">
                                          {{item.phoneNumber}}
                                        </div>
                                      </div>
                                    </div>
                                    <div></div>
                                  </div>
                                </li>
                              </ng-container>
                              <ng-container *ngIf="tab ==='driver'">
                                <li *ngFor="let item of drivers | filter : search2" (click)="onSelectDriver(item)"
                                  class="relativs relative cursor-pointer  px-4 py-2 hover:bg-gray-100 dark:bg-white/5 dark:hover:bg-white/5"
                                  [ngClass]="selectedDrivers.includes(item.id) ? 'bg-gray-200' : 'bg-white'">
                                  <span class="absolute inset-y-0 left-0 z-10 h-full w-2"
                                    [ngClass]="selectedDrivers.includes(item.id) ? 'bg-blue-800' : 'bg-gray-200 dark:bg-white/10'">
                                  </span>
                                  <div class="flex items-center justify-between">
                                    <div class="flex flex-1 items-center gap-2">
                                      <div
                                        class="inline-grid size-10 shrink-0 rounded-[--avatar-radius] align-middle outline outline-1 -outline-offset-1 outline-black/[--ring-opacity] [--avatar-radius:20%] [--ring-opacity:20%] *:rounded-[--avatar-radius] dark:outline-white/[--ring-opacity] overflow-hidden">
                                        <img alt="Profile Image"
                                          class="ng-star-inserted relative size-full text-gray-400 object-cover"
                                          src="{{item.profileImageURL ? item.profileImageURL : 'assets/images/company-placeholder.png'}}" />
                                      </div>
                                      <div class="flex flex-col">
                                        <div class="text-sm-dark font-bold leading-tight text-primary">
                                          {{item.firstName}} {{item.lastName}}
                                        </div>
                                        <div class="text-sm-light leading-tight" phoneNumberFormat [phoneNumber]="item.phoneNumber">
                                          {{item.phoneNumber}}
                                        </div>
                                        <div class="text-sm-light font-bold leading-tight"
                                          *ngIf="item.company && preCompanies && preCompanies[item.company]">
                                          {{preCompanies[item.company].name}}</div>
                                      </div>
                                    </div>
                                    <div></div>
                                  </div>
                                </li>
                              </ng-container>
                            </ul>
                          </div>
                          <div class="order-4 flex h-full w-full flex-1 flex-col overflow-y-auto px-1 lg:order-2">
                            <div class="mb-2 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                              <div class="flex flex-col gap-4 sm:flex-row sm:gap-2">
                                <div class="relative">
                                  <input type="text" [(ngModel)]="search" placeholder="Search.."
                                    class="ng-untouched ng-pristine ng-valid pl-8" /><svg
                                    xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke-width="1.5" stroke="currentColor"
                                    class="absolute left-2 top-1/2 size-5 -translate-y-1/2 transform">
                                    <path stroke-linecap="round" stroke-linejoin="round"
                                      d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z">
                                    </path>
                                  </svg>
                                </div>
                              </div>
                              <div>
                                <h1 class="text-nowrap text-left text-xs">Showing {{trips.length}} entries</h1>
                              </div>
                            </div>
                            <div class="mt-2 flex items-center gap-1 text-primary">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="size-4">
                                <path fill="currentColor"
                                  d="M12.442 21.5L8.981 5.489L6.396 17.5H2.5v-1h3.085l2.806-13h1.186l3.473 16.07L15.366 9.5h1.25l1.8 7H21.5v1h-3.866l-1.623-6.354L13.635 21.5z">
                                </path>
                              </svg>
                              <h2 class="subheading text-primary">Trips</h2>
                            </div>
                            <div class="w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
                              <div class="flow-root h-96 overflow-y-auto">
                                <div class="-my-2">
                                  <div class="inline-block min-w-full py-2 align-middle">
                                    <table class="min-w-full border-separate border-spacing-0">
                                      <thead>
                                        <tr>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            #
                                          </th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Actions</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Status</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Reference ID
                                          </th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Rate <span class="text-xs text-gray-600">(FS)</span></th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Special Fare</th>
                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Service Area</th>



                                          <th *ngIf="status !== 'scheduled'"
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Company</th>

                                          <th *ngIf="status !== 'scheduled'"
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Driver</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Member</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Contact No.</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Pickup Time
                                          </th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Dropoff Time
                                          </th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Pickup Address</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Dropoff Address</th>


                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Miles</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Space Type</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            LOS</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Appointment Type</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            Created At</th>

                                          <th
                                            class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            General Notes</th>

                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr *ngFor="let trip of trips | filter : search let i = index;"
                                          class="hover:bg-gray-950/5 dark:hover:bg-white/10 relative ">
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span class="text-sm text-light">{{i + 1}}</span>
                                          </td>
                                          <!-- status -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <button *ngIf="trips.length > 1" type="button"
                                              class="btn btn-danger rounded-full size-6 grid place-content-center"
                                              (click)="removeTrip(i)">
                                              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-4">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                  d="M6 18L18 6M6 6l12 12" />
                                              </svg>
                                            </button>
                                          </td>
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span class="my-1" [ngClass]="{
                                          'badge-danger': trip?.status === 'cancelled' || trip?.status === 'reroute',
                                          'badge-success': trip?.status !== 'cancelled' && trip?.status !== 'reroute'
                                        }"> {{trip?.status | titlecase}} </span>
                                          </td>
                                          <!-- Reference -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span>
                                              {{ trip.reference || 'N/A' }}{{trip.suffix ? '-' + trip.suffix : '' }}
                                            </span>
                                          </td>
                                          <!-- fare total -->
                                          <td
                                            class="px-3 py-1 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <div class="text-sm-dark font-medium" *ngIf="trip?.fare; else elseBlock">
                                              ${{ (trip?.fare?.total.toFixed(2)) || 'N/A' }}
                                            </div>
                                            <ng-template class="" #elseBlock>
                                              <div class="text-sm-light">N/A</div>
                                            </ng-template>
                                          </td>
                                          <!-- fare total -->
                                          <td
                                            class="px-3 py-1 border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <div class="text-sm-dark font-medium">
                                              ${{trip.specialRate}}
                                            </div>

                                          </td>
                                          <!-- Service Areas -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preServiceAreas && preServiceAreas[trip.serviceArea]">
                                              {{preServiceAreas[trip.serviceArea].title ?
                                              (preServiceAreas[trip.serviceArea].title | titlecase) : 'N/A'}}
                                            </span>
                                          </td>
                                          <!-- company -->
                                          <td *ngIf="status !== 'scheduled'"
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preCompanies && preCompanies[trip.company]">
                                              {{preCompanies[trip.company].name | titlecase}}
                                            </span>
                                          </td>
                                          <!-- driver -->
                                          <td *ngIf="status !== 'scheduled'"
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.driver ? ((trip.driver.displayName) | titlecase) : 'NA'}}</td>
                                          <!-- member -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span>
                                              {{(trip?.member.displayNamee) | titlecase}}
                                            </span>
                                          </td>
                                          <!-- phoneNumber -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" phoneNumberFormat [phoneNumber]="trip?.pickup?.phoneNumber">
                                            {{trip?.pickup.phoneNumber || 'N/A'}}</td>
                                          <!-- pickuptime -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.pickup.time | date: 'MM/DD/YYYY HHmm'}}</td>
                                          <!-- DO time -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.destination.time | date: 'MM/DD/YYYY HHmm'}}</td>

                                          <!-- pickup address -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.pickup?.address?.name}}</td>
                                          <!-- destination address -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.destination?.address?.name}}</td>
                                          <!-- miles -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip?.miles?.toFixed(2)}} mi</td>

                                          <!-- spaceType -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preSpacetypes && preSpacetypes[trip.spaceType]">
                                              {{preSpacetypes[trip.spaceType].title | uppercase}}
                                            </span>
                                          </td>
                                          <!-- LOS -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <!-- N/A -->
                                            <span *ngIf="preLevelOfService && preLevelOfService[trip.levelOfService]">
                                              {{preLevelOfService[trip.levelOfService].title | uppercase}}
                                            </span>
                                          </td>
                                          <!-- appointmentType -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            <span *ngIf="preAppointmentType && preAppointmentType[trip.appointmentType]">
                                              {{(preAppointmentType[trip.appointmentType].title | titlecase) || 'N/A'}}
                                            </span>
                                          </td>
                                          <!-- createdAt -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                            {{trip.createdAt | date: 'MM/DD/YYYY HHmm'}}</td>
                                          <!-- generalNotes -->
                                          <td
                                            class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 ">
                                            <div class="w-72 line-clamp-2">
                                              {{trip.generalNotes}}
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="border-t border-zinc-200 px-4 py-2 dark:border-white/10">
                          <div class="flex items-center justify-end gap-2">
                            <button (click)="distribute()" class="btn btn-secondary">Distribute</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>